import { configureStore } from '@reduxjs/toolkit'
import { pageAction } from './Actions/page'
import { requestsAction } from './Actions/requests'
import { createRequestDetailsAction } from './Actions/createRequestDetails'
import { requestUserAction } from './Actions/requestUser'
import { serviceDetailAction } from './Actions/serviceDetail'
import { branchDetailAction } from './Actions/branchDetail'

export const store = configureStore({
  reducer: {
    PageStore:pageAction.reducer,
    RequestsStore:requestsAction.reducer,
    CreateRequestDetailsStore:createRequestDetailsAction.reducer,
    requestUserStore:requestUserAction.reducer,
    serviceDetailsStore:serviceDetailAction.reducer,
    branchDetailStore:branchDetailAction.reducer
  },
})